<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="vue-cropper">
                <el-button style="position:relative" type="primary">
                    <span>update</span>
                    <input type="file" name="image" accept="image/*" @change="setImage" />
                </el-button>
                <vue-cropper
                    ref='cropper'
                    :guides="true"
                    :view-mode="2"
                    drag-mode="crop"
                    :auto-crop-area="0.5"
                    :min-container-width="250"
                    :min-container-height="180"
                    :background="true"
                    :rotatable="true"
                    :src="imgSrc"
                    alt="Source Image"
                    :img-style="{ 'width': '400px', 'height': '300px' }">
                </vue-cropper>
                <el-button @click="cropImage">crop</el-button>
                <el-button @click="rotate">rotate</el-button>
                <img :src="cropImg" style=" border: 1px solid gray" alt="Cropped Image" />
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import VueCropper from 'vue-cropperjs';
    export default {
        data(){
            return {
                imgSrc: "",
                cropImg:'',
            }
        },
        created(){
            this.$parent.routerLoading();
        },
        methods:{
            setImage(e) {
                const file = e.target.files[0];
                if (!file.type.includes('image/')) {
                  alert('Please select an image file');
                  return;
                }
                if (typeof FileReader === 'function') {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  alert('Sorry, FileReader API not supported');
                }
            },
            cropImage() {
                // get image data for post processing, e.g. upload or setting image src
                this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            rotate() {
                // guess what this does :)
                this.$refs.cropper.rotate(90);
            },
        },
        components: { VueCropper},
        mounted(){
        }
    }
</script>
<style>
    input[type='file']{
        display:block;
        width:100%;
        height:100%;
        position:absolute;
        top: 0;
        left: 0;
        opacity:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/VueCropper.vue